// Header_User.js
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { clearUser, fetchUser } from './../../redux/userSlice';

import { debug } from './../../utils'
import UserSignInModal from './UserSignInModal';

function Header_User() {
  const navigate = useNavigate
  const { t } = useTranslation();// ['user', 'common']
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user);
  const [showModal, setShowModal] = useState(false);
  const handleSignOut = () => {
    dispatch(clearUser());
  }
  useEffect(() => {
    dispatch(fetchUser()); // Appelle l'action fetchUser() pour récupérer l'utilisateur initialement
    const interval = window.setInterval(() => {
      dispatch(fetchUser());
    }, 60000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <>
      {!user.isSignedIn ? (
        <span className='pointer' onClick={e => setShowModal(true)}>{t('Signin')}</span>
      ) : (
        <>
          {user.type && <Link to={`/${user.type.toLowerCase()}/home`}>{t('MyAccount')}</Link>}
          <Link onClick={handleSignOut} className="nav-link">{t('Signout')}</Link>
        </>
      )}

      <UserSignInModal show={showModal} options={{ onSigned: '/user/account' }} onClose={e => setShowModal(false)} onSuccess={e => setShowModal(false)} />
    </>
  );

}
export default Header_User;


